import { ChooseTheAnswer, FillTheGaps, WordsBank } from "./styled";

const exercises = { FillTheGaps, WordsBank, ChooseTheAnswer };
export default exercises;
